module.exports = __webpack_public_path__ + "static/media/bitcoin.e9dbce76.png";